import React, { memo } from "react";
import { Link } from "react-router-dom";

const AgentTable = memo(({ agents, onToggleStatus, onDelete }) => {
  return (
    <div className="tw-overflow-x-auto">
      <table className="tw-min-w-full tw-divide-y tw-divide-gray-200">
        <thead className="tw-bg-gray-50">
          <tr>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Name</th>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Username</th>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Phone</th>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Balance</th>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Cut</th>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Role</th>
            <th className="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Status</th>
            <th className="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
          {agents.map(agent => (
            <tr key={agent._id} className="hover:tw-bg-gray-50">
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap">
                <div className="tw-flex tw-items-center">
                  <img
                    src={agent.avatar || "/default-avatar.png"}
                    alt="Profile"
                    className="tw-w-10 tw-h-10 tw-rounded-full tw-object-cover"
                    onError={(e) => { e.target.src = "/default-avatar.png" }}
                  />
                  <div className="tw-ml-4">
                    <div className="tw-text-sm tw-font-medium tw-text-gray-900">{agent.name}</div>
                  </div>
                </div>
              </td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">{agent.username}</td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">{agent.phone || '-'}</td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">{agent.balance?.toLocaleString() || '0'}</td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">{agent.cut}%</td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500 tw-capitalize">{agent.role}</td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-center">
                <button
                  onClick={() => onToggleStatus(agent._id, agent.status)}
                  className={`tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold ${
                    agent.status 
                      ? 'tw-bg-green-100 tw-text-green-800' 
                      : 'tw-bg-red-100 tw-text-red-800'
                  }`}
                >
                  {agent.status ? 'Active' : 'Inactive'}
                </button>
              </td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500 tw-text-center tw-space-x-4">
                <button
                  onClick={() => onDelete(agent._id)}
                  className="tw-text-red-600 hover:tw-text-red-800"
                >
                  Delete
                </button>
                <Link
                  to={`/updateagent/${agent._id}`}
                  className="tw-text-indigo-600 hover:tw-text-indigo-800"
                >
                  Edit
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default AgentTable;